import templateUrl from "emun.order/order-list-cards.htm";

export default () => ({ templateUrl });
